import React from 'react'
import { Button, CircularProgress } from '@mui/material'
import { IProduct } from '../../../types/products'

interface OrderSummaryProps {
  cart: IProduct[]
  takeaway: boolean
  location: any
  loading: boolean
  handleCheckout: () => void
  t: (key: string) => string
}

const OrderSummary: React.FC<OrderSummaryProps> = ({
  cart,
  takeaway,
  location,
  loading,
  handleCheckout,
  t,
}) => {
  const totalPrice = cart.reduce(
    (total, item) => total + Number(item.price) * item.quantity!,
    0
  )

  const deliveryCost = takeaway ? 0 : location?.delivery_price || 0

  return (
    <div className='checkout-page__container-footer'>
      <div className='checkout-page__container-footer-total'>
        <div className='checkout-page__container-footer-total-item'>
          <div className='checkout-page__container-footer-total-item-label'>
            {t('ORDER_SUM')}
          </div>
          <div className='checkout-page__container-footer-total-item-value'>
            {totalPrice} lei
          </div>
        </div>
        <div className='checkout-page__container-footer-total-item'>
          <div className='checkout-page__container-footer-total-item-label'>
            {t('DELIVERY')}
          </div>
          <div className='checkout-page__container-footer-total-item-value'>
            {deliveryCost} lei
          </div>
        </div>
        <div className='checkout-page__container-footer-total-item total'>
          <div className='checkout-page__container-footer-total-item-label'>
            {t('TOTAL')}
          </div>
          <div className='checkout-page__container-footer-total-item-value'>
            {totalPrice + deliveryCost} lei
          </div>
        </div>
        <div className='checkout-page__container-footer-total-checkout'>
          <Button
            variant='contained'
            disabled={loading || cart.length === 0}
            onClick={handleCheckout}
            sx={{
              backgroundColor: '#ff1647',
              textTransform: 'none',
              fontSize: '16px',
              fontWeight: 'bold',
              width: '100%',
              '&:hover': { backgroundColor: '#cc1138' },
            }}
          >
            {loading ? (
              <CircularProgress
                size='2rem'
                thickness={5}
                sx={{ color: '#ff1647' }}
              />
            ) : (
              t('ORDER')
            )}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default OrderSummary
